// Validates numbers with up to 16 digits before and 4 digits after decimal
export const fourDecimalNumberValidation = {
    validate: (value) => {
        if (value && value < 0) {
            return 'Invalid amount. Must be greater than 0';
        }
        return true;
    },
    pattern: {
        value: /^-?(?:\d{1,16})(?:\.\d{1,4})?$/,
        message: 'Invalid amount. Can be up to 16 digits with max 4 decimal places',
    },
};
// validates numbers with up to 16 digits before and 2 digits after decimal
export const numberValidation = {
    validate: (value) => {
        if (value && value < 0) {
            return 'Invalid amount. Must be greater than 0';
        }
        return true;
    },
    pattern: {
        value: /^-?(?:\d{1,16})(?:\.\d{1,2})?$/,
        message: 'Invalid amount. Can be up to 16 digits with max 2 decimal places',
    },
};

export const integerValidation = ({ min = 0, max = null }) => ({
    validate: (value = 0) => {
        if (value && value <= min) {
            return `Invalid amount. Must be greater than ${min}`;
        }
        if (value && max && value > max) {
            return `Must be less or equal to ${max}`;
        }
        return true;
    },
    pattern: {
        value: /^-?\d+$/,
        message: 'Invalid amount. Must be an integer',
    },
    type: 'number',
});

// validates numbers with up to 7 digits before and 2 digits after decimal
export const currencyValidation = {
    validate: (value) => {
        if (value && value < 0) {
            return 'Invalid amount. Must be greater than 0';
        }
        return true;
    },
    pattern: {
        value: /^-?(?:\d{1,7})(?:\.\d{1,2})?$/,
        message: 'Invalid amount. Can only be up to 7 digits with max 2 decimal places',
    },
};
